import { calculateDistanceBetweenCoordinates } from '@/domain/position-geocode/utils/calculate-distance/calculate-distance';
import { createAppAsyncThunk } from '@/domain/store.thunk';

import { TourEvent } from '../entities/project-tour-ontour-event.entity';
import { TourTravel } from '../entities/project-tour-ontour-travel.entity';
import { selectProjectTourOnTourEvents } from '../project-tour-ontour.selectors';
import { editTourTravel } from './edit-tour-travel.action';

type Params = {
  tourTravel: TourTravel;
};

type Result = void;

export const calculateDirectTravelDistanceAndEditTourTravel =
  createAppAsyncThunk(
    'projectTourOntour/calculateDirectTravelDistanceAndEditTourTravel',
    async (params: Params, { dispatch, getState }): Promise<Result> => {
      const tourEvents = selectProjectTourOnTourEvents(getState());
      const travelDistance = await prepareTravelDistance(
        tourEvents,
        params.tourTravel.fromEventId,
        params.tourTravel.toEventId,
      );
      const newTourTravel: TourTravel = {
        ...params.tourTravel,
        travelDistance: travelDistance,
      };
      await dispatch(editTourTravel({ tourTravel: newTourTravel }));
    },
  );

async function prepareTravelDistance(
  tourEvents: TourEvent[],
  fromTourEventId: number | undefined,
  toTourEventId: number | undefined,
) {
  const fromEvent = tourEvents.find((item) => item.id === fromTourEventId);
  const toEvent = tourEvents.find((item) => item.id === toTourEventId);
  const from = fromEvent?.position?.coordinates;
  const to = toEvent?.position?.coordinates;
  let travelDistance: number;
  try {
    travelDistance = await calculateDistanceBetweenCoordinates(from, to);
  } catch (error) {
    console.error('error calculating distance', error);
    travelDistance = 0;
  }
  return travelDistance;
}
